<template>
  <div
    class="discussBox wxDiscussBox"
    ref="discussBox"
    id="discussBox"
    v-if="this.commentlists.length > 0"
  >
    <p class="fgx" v-if="commonType != 'keepRecord'"></p>
    <h4 class="ggTit">全部评论</h4>
    <div class="list-content" id="list-content">
      <div class="list-item">
        <van-cell
          v-for="(item, index) in commentlists"
          :key="item.id"
          class="item"
        >
          <div class="critic">
            <dl class="criticInfo" @click="getAppComment(item, index)">
              <dt class="criticImg">
                <img :src="item.readerImg" alt />
              </dt>
              <dd class="criticName">
                {{ item.readerName }}【{{ item.commentTime }}】
              </dd>
              <dd class="criticmain">{{ item.content }}</dd>
            </dl>

            <van-cell
              v-for="childItem in item.children"
              :key="childItem.id"
              class="childItem"
            >
              <div class="critic">
                <dl class="criticInfo" @click="getAppComment(item, index)">
                  <dt class="criticImg">
                    <img :src="childItem.readerImg" alt />
                  </dt>
                  <dd class="criticName">
                    {{ childItem.readerName }} 回复
                    {{ childItem.beReaderName }}【{{ childItem.commentTime }}】
                  </dd>
                  <dd class="criticmain">{{ childItem.content }}</dd>
                </dl>
              </div>
            </van-cell>
          </div>
        </van-cell>
      </div>
    </div>
    <div class="commentModule clearfix">
      <van-cell-group class="commentCase fl">
        <van-field
          v-model="commontValue"
          :placeholder="placeholderText"
          right-icon="clear"
          @click-right-icon="clearCommentValue"
        />
      </van-cell-group>
      <van-button
        type="info"
        size="small"
        @click="saveComment"
        class="fr sureBtn"
        >确定</van-button
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { getCurTime } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { mapState, mapMutations } from "vuex";
export default {
  name: "wxDiscussBox",
  props: ["ktId", "allowComment"],
  data() {
    return {
      commentlists: [],
      contentId: "", //评论所属id
      commonType: "", //评论所属类型
      clientType: "", //手机类型
      placeholderText: "请输入评论...",
      commontValue: "", //评论框的值
      firstId: "", //首条评论ID
      replyId: "", //回复评论ID
      itemIndex: "", //点击所属下标
      itemIndexdata: {}, //所属下标的头像图片
    };
  },

  mounted() {
    window.commentReload = this.reloadPage;
    this.commonType = this.$route.query.commonType;
    this.clientType = getDeviceType();
    this.$nextTick(() => {
      this.contentId = this.ktId;
      console.log("userinfo", this.userinfo);
      if (this.contentId) {
        this.getTest();
      }
      if (this.allowComment) {
        console.log("可以评论");
      }
    });
  },
  methods: {
    //渲染评论列表
    getTest() {
      let _this = this;
      _this.$api.baseCommon.baseMsg
        .getCommentList(_this.commonType, _this.contentId)
        .then((res) => {
          if (res.code == "1") {
            _this.commentlists = res.data;
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    getAppComment(item, itemIndex) {
      let _this = this;
      console.log(item);
      _this.itemIndex = itemIndex;
      _this.firstId = item.firstId ? item.firstId : "";
      _this.replyId = item.replyId ? item.replyId : "";
      _this.placeholderText = "回复：" + item.readerName;
      _this.itemIndexdata = item;
    },
    clearCommentValue() {
      let _this = this;
      _this.placeholderText = "请输入评论...";
      _this.commontValue = "";
      _this.firstId = "";
      _this.replyId = "";
      _this.itemIndex = "";
      _this.itemIndexdata = {};
    },
    saveComment() {
      //保存评论
      let _this = this;
      let childItem = {
        content: _this.commontValue,
        firstId: _this.firstId,
        replyId: "33",
        beReaderName: _this.itemIndexdata.readerName,
        readerImg: _this.userinfo.avatar,
        readerName: _this.userinfo.realName,
        commentTime: getCurTime(),
      };
      console.log(_this.commentlists[_this.itemIndex].children);
      let sourceData = _this.commentlists[_this.itemIndex];
      console.log(sourceData,"sourceData");
      console.log(sourceData.children,"children")
      sourceData.children.push(childItem);
      // _this.$api.baseCommon.baseMsg
      //   .setCommentList({
      //     content: _this.commontValue,
      //     firstId: _this.firstId,
      //     noticeId: _this.contentId,
      //     replyId: _this.replyId,
      //   })
      //   .then((res) => {
      //     if (res.code == "1") {
      //       if (res.data) {
      //         if (_this.firstId != "" || _this.replyId != "") {
      //           let childItem = {
      //             content: _this.commontValue,
      //             firstId: _this.firstId,
      //             replyId: res.data,
      //             beReaderName: _this.itemIndexdata.readerName,
      //             readerImg: _this.userinfo.avatar,
      //             readerName: _this.userinfo.realName,
      //             commentTime: getCurTime(),
      //           };
      //           console.log(_this.commentlists[_this.itemIndex].children);
      //           let sourceData = _this.commentlists[_this.itemIndex];
      //           console.log(_this.commentlists[_this.itemIndex]);
      //           sourceData.children.push(children);
      //           // _this.commentlists[_this.itemIndex].children.push(children);
      //         } else {
      //           let Item = {
      //             content: _this.commontValue,
      //             readerImg: _this.userinfo.avatar,
      //             firstId: res.data,
      //             readerName: _this.userinfo.realName,
      //             commentTime: getCurTime(),
      //           };
      //           _this.commentlists.push(Item);
      //         }
      //       }
      //     } else {
      //       console.log(res.msg);
      //     }
      //   })
      //   .catch((err) => {
      //     this.finished = true;
      //     console.log(err);
      //   });
    },
    reloadPage: function () {
      this.commentlists = [];
      setTimeout(() => {
        this.getTest();
      }, 300);
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    ktId: function (newVal) {
      this.contentId = newVal;
      if (this.contentId) {
        this.getTest();
      }
    },
    allowComment: function (newVal) {
      if (newVal) {
        console.log("可以评论");
      }
    },
  },
};
</script>

<style lang="less">
@import "./css/discussBox.less";
</style>
<style lang="less">
.wxDiscussBox {
  position: relative;
  .commentModule {
    width: 100%;
    padding: 3px 5px;
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #f6f6f6;
    .commentCase {
      width: 75%;
      .van-cell {
        padding: 5px 8px;
      }
      .van-icon {
        opacity: 0.5;
      }
    }
    .sureBtn {
      margin-top: 3px;
    }
  }
}
</style>